export const PageTitle = ({ title }: any) => {
    return (
        <div className="bg-deep-purple-accent-700">
            <div className="px-0 py-10 mx-auto sm:max-w-xl md:max-w-full lg:max-w-full md:px-0 lg:px-0 lg:py-10 items-center text-center">
                <h1 className="mb-0 font-sans text-3xl font-bold leading-none tracking-tight text-white sm:text-4xl md:mx-auto">
                    <span className="relative inline-block">
                        <svg
                            viewBox="0 0 52 24"
                            fill="currentColor"
                            className="absolute top-0 left-0 z-0 hidden w-32 -mt-8 -ml-20 text-deep-purple-accent-100 lg:w-32 lg:-ml-28 lg:-mt-10 sm:block"
                        >
                            <defs>
                                <pattern
                                    id="700c93bf-0068-4e32-aafe-ef5b6a647708"
                                    x="0"
                                    y="0"
                                    width=".135"
                                    height=".30"
                                >
                                    <circle cx="1" cy="1" r=".7" />
                                </pattern>
                            </defs>
                            <rect
                                fill="url(#700c93bf-0068-4e32-aafe-ef5b6a647708)"
                                width="52"
                                height="24"
                            />
                        </svg>
                        <span className="relative">{title}</span>
                    </span>
                </h1>
            </div>
        </div>
    );
};
